import "./FabYouth.css";

function FabYouth({ page, settings }) {
 const content = page?.content || {};
 const themeMode =
  String(settings?.theme_mode || "dark").trim().toLowerCase() === "light"
   ? "light"
   : "dark";

 const heroTitle = content.hero_title || "3 ON 3";

 const introSectionTitle =
  content.intro_section_title || "WHAT IS 3 ON 3 BASKETBALL?";
 const introText =
  content.intro_text ||
  "3-on-3 basketball is a fast-paced and exciting variation of traditional basketball where teams of three players compete against one another. Each game typically takes place on half of a basketball court, allowing for quicker play and more scoring opportunities for each player.";

 const benefitsSectionTitle =
  content.benefits_section_title || "WHY 3 ON 3?";

  const benefitsText =
    content.benefits_lines_text?.trim() ||
    `Enhanced Skill Development
More Touches on the Ball: With fewer players on the court, each player has more opportunities to handle the ball, improving their dribbling, passing, and shooting skills.
Versatility: Players are encouraged to develop a well-rounded skill set since they will play both offensive and defensive roles.

Increased Participation
Smaller Teams: The smaller team size allows for more involvement, ensuring that all players are engaged in the game rather than being sidelined.
Friendlier Atmosphere: 3-on-3 promotes a more intimate setting where players can bond and build friendships, enhancing the overall enjoyment of the sport.

Faster Game Pace
Quick Matches: Games are typically shorter, leading to quicker rotations and allowing players to participate in multiple games in one day.
Less Downtime: The fast pace minimizes waiting times between plays, creating a more exciting and dynamic environment.`;

  const benefitGroups = benefitsText
    .split(/\n\s*\n/)
    .map((group) => group.trim())
    .filter(Boolean)
    .map((group) => {
      const lines = group.split("\n").map((line) => line.trim()).filter(Boolean);
      const heading = lines[0] || "";
      const items = lines.slice(1).map((line) => {
        const [label, ...rest] = line.split(":");
        return {
          label: label?.trim() || "",
          description: rest.join(":").trim(),
        };
      });

      return { heading, items };
    });

 const closingText =
  content.benefits_closing_text ||
  "FAB’s 3-on-3 format offers a unique and engaging approach to basketball, emphasizing skill development, teamwork, and community, making it ideal for youth players looking to enjoy the game and build confidence.";

 const registerSectionTitle =
  content.register_section_title || "HOW TO REGISTER";

 const registerText =
  content.register_text ||
  "Email us to register and learn more about upcoming youth 3-on-3 opportunities.";

  const detectedEmail =
    registerText.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i)?.[0] || "";
 return (
  <div className={`fab-youth ${themeMode}`}>
   <section className="fab-youth-hero section-wrapper">
    <div className="fab-youth-hero-inner">
     <h1>{heroTitle}</h1>
    </div>
   </section>

   <section className="fab-youth-section section-wrapper">
    <div className="fab-youth-section-content">
     <h2>{introSectionTitle}</h2>
     <div>
      <p>{introText}</p>
     </div>
    </div>
   </section>

   <hr className="fab-youth-divider" />

   <section className="fab-youth-section section-wrapper">
    <div className="fab-youth-section-content">
     <h2>{benefitsSectionTitle}</h2>

     <div>
           <div className="fab-youth-benefits-list">
             {benefitGroups.map((group, index) => (
               <div key={index} className="fab-youth-benefit-group">
                 <h3>{group.heading}</h3>

                 <ul>
                   {group.items.map((item, itemIndex) => (
                     <li key={itemIndex}>
                       <strong>{item.label}:</strong> {item.description}
                     </li>
                   ))}
                 </ul>
               </div>
             ))}
           </div>

      <p className="fab-youth-closing-text">{closingText}</p>
     </div>
    </div>
   </section>

   <hr className="fab-youth-divider" />

   <section className="fab-youth-section section-wrapper">
    <div className="fab-youth-section-content">
     <h2>{registerSectionTitle}</h2>

     <div className="fab-youth-register-box">
           <p>
             {detectedEmail
               ? registerText.split(detectedEmail).map((part, index, arr) => (
                 <span key={index}>
                   {part}
                   {index < arr.length - 1 && (
                     <a
                       href={`mailto:${detectedEmail}`}
                       className="fab-youth-email-link"
                     >
                       {detectedEmail}
                     </a>
                   )}
                 </span>
               ))
               : registerText}
           </p>

     </div>
    </div>
   </section>
  </div>
 );
}

export default FabYouth;